import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { AuthenticationService } from '../shared/authentication.service';
import { LoginComponent } from './login.component';
import { PublicAccessTerminalService } from '../shared/public-access-terminal.service';

// export enum Reason {
//   Inactivity = 'inactivity'
// };

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.less']
})
export class LogoutComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private authenticationService: AuthenticationService,
              private modalService: BsModalService,
              private publicAccessTerminalService: PublicAccessTerminalService,
              private router: Router) {
                if (this.publicAccessTerminalService.isPublicAccessTerminal()) {
                  this.router.navigateByUrl('/');
                }
              }

  ngOnInit() {
    // If the user goes back in history to the logout page, log them out.
    if (this.authenticationService.isUserLoggedIn()) {
      this.authenticationService.logOut();
    }

    // Hide any modals which are open
    const modalCount = this.modalService.getModalsCount();
    for (let i = modalCount; i > 0; i--) {
      this.modalService.hide(i);
    }

    setTimeout(() => {
      this.showLoginPrompt().then(() => {
        this.router.navigateByUrl('/');
      });
    }, modalCount ? 1000 : 0); // use a timeout if we need to wait for modals to close
    // Note: this timeout unfortunately is needed to solve an issue whereby the modal-hiding code also hides the login modal
    // we need to open.
    // ngx-bootstrap modals have a few issues which contribute to that. If you hide the sessionTimeout modal prior to
    // coming here (using bsModalRef.hide()), there's a delay before the modalsCount gets updated. Calls to hide modals using the
    // modalservice don't immediately update the modalsCount, as that happens after an internal timeout (for animation to occur).
    // Also, solutions which try to key off the "onHidden" EventEmitter also don't work, because multiple events are sometimes
    // emitted upon a single modal hide.
    // The timeout allows the modal hiding to all take place prior to the login modal being opened. The net result is a briefly blank
    // screen before the login modal is shown.
  }

  private showLoginPrompt(): Promise<boolean> {
    // not logged in so route to 'login' and return false
    const bsModalRef = this.modalService.show(LoginComponent, {class: 'modal-lg', backdrop: 'static'});

    // Display reason for logout
    const reason = this.route.snapshot.paramMap.get('reason');
    setTimeout(() => { bsModalRef.content.logOutReason = reason; });

    return new Promise<boolean>((resolve, reject) => {
        bsModalRef.content.loginCompleted$.subscribe(value => {
            resolve(value);
            bsModalRef.hide();
        });
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/login/logout.component.ts